import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FileText } from "lucide-react";
import { format } from "date-fns";

export default function RecentReports({ reports }) {
  return (
    <Card className="border-none shadow-lg">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="w-5 h-5" />
          Recent Failure Reports
        </CardTitle>
      </CardHeader>
      <CardContent>
        {reports.length === 0 ? (
          <p className="text-slate-500 text-center py-4">No reports uploaded yet</p>
        ) : (
          <div className="space-y-3">
            {reports.map((report) => (
              <div key={report.id} className="p-4 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium text-slate-900">
                      Report: {format(new Date(report.report_date), 'MMMM d, yyyy')}
                    </p>
                    <p className="text-sm text-slate-600 mt-1">
                      {report.entries_added} entries added
                      {report.duplicates_removed > 0 && ` • ${report.duplicates_removed} duplicates removed`}
                    </p>
                    {report.upload_notes && (
                      <p className="text-xs text-slate-500 mt-1">{report.upload_notes}</p>
                    )}
                  </div>
                  <Badge className="bg-green-100 text-green-800">Processed</Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}